import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { VersionHttpService } from './version.http.service';
import { LogService } from '../../log/log.service';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class VersionStore {
  private currentFrontendVersion: Subject<Object> = new Subject();
  private currentBackendVersion: Subject<Object> = new Subject();

  constructor(private versionHttp: VersionHttpService,
              private logService: LogService) {
  }

  getFrontendVersion(): Observable<Object> {
    this.versionHttp.getFrontendVersion().subscribe(versionObj => {
      this.logService.verbose(`VersionStore versionObj: ${JSON.stringify(versionObj)}`);
      this.currentFrontendVersion.next(versionObj);
    });

    return this.currentFrontendVersion.asObservable();
  }

  getBackendVersion(): Observable<Object> {
    this.versionHttp.getBackendVersion().subscribe(versionObj => {
      this.logService.verbose(`VersionStore versionObj: ${JSON.stringify(versionObj)}`);
      this.currentBackendVersion.next(versionObj);
    });

    return this.currentBackendVersion.asObservable();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/version/service/version.store.ts